import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";

const COOKIE_KEY = "fc_cookie_consent";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_KEY, "accepted");
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(COOKIE_KEY, "declined");
    // Disable GA and Meta Pixel
    window[`ga-disable-G-82F1W3S96B` as any] = true;
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", damping: 25, stiffness: 200 }}
          className="fixed bottom-0 inset-x-0 z-50 p-4 sm:p-6"
        >
          <div className="max-w-xl mx-auto bg-card border border-border rounded-2xl p-5 shadow-xl flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <p className="font-body text-sm text-muted-foreground flex-1">
              We use cookies for analytics and to improve your experience.{" "}
              <Link to="/privacy" className="text-primary hover:underline">Learn more</Link>.
            </p>
            <div className="flex gap-2 shrink-0">
              <button
                onClick={decline}
                className="font-body text-xs text-muted-foreground hover:text-foreground px-3 py-2 transition-colors"
              >
                Decline
              </button>
              <button
                onClick={accept}
                className="font-display text-xs uppercase tracking-wider bg-primary text-primary-foreground px-4 py-2 rounded-lg hover:bg-primary/90 transition-colors"
              >
                Accept
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
